import GreLogo from '../../icons/course-details-page/GreLogo';
import GmatLogo from '../../icons/course-details-page/GmatLogo';
import EnglishExamLogo from '../../icons/utility-cards/EnglishExamLogo';
import EuropeLogo from '../../icons/utility-cards/EuropeLogo';
import StudentLogo from '../../icons/utility-cards/StudentLogo';
import TwelfthLogo from '../../icons/utility-cards/TwelfthLogo';
import UgLogo from '../../icons/utility-cards/UgLogo';
import SpecialAppFeeLogo from '../../icons/utility-cards/SpecialAppFeeLogo';
import QuickOfferLogo from '../../icons/utility-cards/QuickOfferLogo';
import PopularLogo from '../../icons/utility-cards/PopularLogo';
import HighRankingLogo from '../../icons/utility-cards/HighRankingLogo';
import AffordableLogo from '../../icons/utility-cards/AffordableLogo';
import EnglishExamExemptedLogo from '../../icons/utility-cards/EnglishExamExemeptedLogo';
import PlacementSupportLogo from '../../icons/utility-cards/PlacementSupportLogo';
import IntakeLogo from '../../icons/utility-cards/IntakeLogo';
export var CardGroupLabelMapper = {
    SIMILAR_COURSES: {
        title: 'Similar Courses',
        subtitle: 'Check out these course suggestions that match the student preferences you previously entered. You can add them to the shortlist'
    },
    UTILITY_FILTERS: {
        title: 'Improve Search Results with Popular Student Requirements',
        subtitle: "Can't find the perfect course? Use these filter suggestions based on the top requirements of similar student profiles"
    },
    USP: {
        title: 'Quick Filter Suggestions',
        subtitle: 'Check out the top course features available for your selected course and click on view courses to filter the courses accordingly'
    }
};
export var iconMapper = {
    gre_count: GreLogo,
    gmat_count: GmatLogo,
    english_exam_type: EnglishExamLogo,
    european_country: EuropeLogo,
    student_selected: StudentLogo,
    twelfth_score_less_than_equal_to: TwelfthLogo,
    ug_score_less_than_equal_to: UgLogo,
    open_intake_count: IntakeLogo,
    intake_count: IntakeLogo,
    GB_APP_FEE_WAIVER: SpecialAppFeeLogo,
    HIGH_OFFER_RATE: SpecialAppFeeLogo,
    QUICKEST_OFFER_TAT: QuickOfferLogo,
    POPULAR_AMONG_GEEBEE: PopularLogo,
    HIGH_RANKING_INSTITUTE: HighRankingLogo,
    AFFORDABILITY: AffordableLogo,
    MOI_ACCEPTED: EnglishExamExemptedLogo,
    PLACEMENT_SUPPORT: PlacementSupportLogo
};
export var UspCardPropsMapper = {
    HIGH_RANKING_INSTITUTE: {
        title: 'High Ranking Institute',
        bucket: 'HIGH_RANKING_INSTITUTE',
        text: 'View courses from the high ranking institutes in Canada offering Masters in Computer Science',
        actionType: 'button'
    },
    PLACEMENT_SUPPORT: {
        title: 'Placement Support',
        bucket: 'PLACEMENT_SUPPORT',
        text: 'View courses from institutions of Canada offering placement support',
        actionType: 'button'
    },
    HIGH_OFFER_RATE: {
        title: 'High Acceptance Rate',
        bucket: 'HIGH_OFFER_RATE',
        text: 'Filter courses from institutions with 70%+ offer rate in the past year',
        actionType: 'button'
    },
    AFFORDABILITY: {
        title: 'Affordable and Value for Money',
        bucket: 'AFFORDABILITY',
        text: 'Tuition fee is almost ₹1 lakhs cheaper than other PGD institutions in Canada',
        actionType: 'button'
    },
    POPULAR_AMONG_GEEBEE: {
        title: 'Popular course among students',
        bucket: 'POPULAR_AMONG_GEEBEE',
        text: 'Courses from institutions popular among students with similar preferences',
        actionType: 'button'
    },
    MOI_ACCEPTED: {
        title: 'English Exam Exempted',
        bucket: 'MOI_ACCEPTED',
        text: 'Student doesn’t need an English Language Certificate to send an application to these institutions',
        actionType: 'button'
    },
    QUICKEST_OFFER_TAT: {
        title: 'Quick Offer',
        bucket: 'QUICKEST_OFFER_TAT',
        text: 'Institutes respond within 3 weeks of successful submission of an application',
        actionType: 'button'
    },
    GB_APP_FEE_WAIVER: {
        title: 'Special App Fee Waiver',
        bucket: 'GB_APP_FEE_WAIVER',
        text: 'View courses offering Application Fee Waivers exclusively on Unisetu',
        actionType: 'button'
    }
};
export var UtilityCardPropsMapper = {
    gmat_count: {
        subTitle: 'Institutes accepting applications without GMAT Exam',
        bucket: 'gmat_count',
        bucketType: "utility",
        actionType: "button"
    },
    twelfth_score_less_than_equal_to: {
        subTitle: 'Institutions accepting 12th scores less than',
        bucket: 'twelfth_score_less_than_equal_to',
        bucketType: "utility",
        actionType: "tabs"
    },
    ug_score_less_than_equal_to: {
        subTitle: 'Institutions accepting UG scores less than',
        bucket: "ug_score_less_than_equal_to",
        bucketType: "utility",
        actionType: "tabs"
    },
    gre_count: {
        subTitle: 'Institutes accepting applications without GRE Exam',
        bucket: "gre_count",
        bucketType: "utility",
        actionType: "button"
    },
    intake_count: {
        subTitle: 'View Open Programs only for Intake',
        bucket: 'intake_count',
        bucketType: "utility",
        actionType: "tabs"
    },
    pte_total_score_less_than_equal_to: {
        subTitle: 'Institutions accepting an overall PTE score of',
        bucket: 'intake_count'
    },
    duolingo_total_score_less_than_equal_to: {
        subTitle: 'Institutions accepting an overall Duolingo score of',
        bucket: 'intake_count'
    },
    ielts_total_score_less_than_equal_to: {
        subTitle: 'Institutions accepting an overall IELTS score of',
        bucket: 'intake_count'
    },
    toefl_total_score_less_than_equal_to: {
        subTitle: 'Institutions accepting an overall TOEFL score of',
        bucket: 'intake_count'
    },
    english_exam_type: {
        subTitle: 'Select an English Exam given by student',
        bucket: "english_exam_type",
        bucketType: "utility",
        actionType: "tabs"
    },
    european_country: {
        subTitle: 'Select a European Country',
        bucket: "european_country",
        bucketType: "utility",
        actionType: "custom"
    },
    student_selected: {
        subTitle: 'Select Student to get personalised results',
        bucket: "student_selected",
        bucketType: "utility",
        actionType: "custom"
    },
    open_intake_count: {
        bucket: "open_intake_count",
        bucketType: "utility",
        actionType: "button"
    }
};
//# sourceMappingURL=utils.js.map